export default __webpack_public_path__ + "static/media/FullTilt.ac78a1b2.png";